'use client';
import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { useShopifyCart } from '../../shopify/useShopifyCart';
import { ShopifyCartContext } from './ShopifyCartProvider';

export const resolveAppShopifyCartFlags = pathname => ({
  shouldCreateCart: pathname?.includes('/onboarding') ?? false,
  hasCheckedPath: true,
});

export const AppShopifyCartProvider = ({ children }) => {
  const pathname = usePathname();
  const [shouldCreateCart, setShouldCreateCart] = useState(false);
  const [hasCheckedPath, setHasCheckedPath] = useState(false);

  useEffect(() => {
    const { shouldCreateCart: createCart, hasCheckedPath: checkedPath } =
      resolveAppShopifyCartFlags(pathname);
    setShouldCreateCart(createCart);
    setHasCheckedPath(checkedPath);
  }, [pathname]);

  const cartState = useShopifyCart({
    shouldCreateCart,
    hasCheckedPath,
  });

  return (
    <ShopifyCartContext.Provider value={cartState}>
      {children}
    </ShopifyCartContext.Provider>
  );
};
